import React, { useState, useEffect } from 'react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinks = [
    ['/', 'Home'],
    ['#about', 'About'],
    ['#ventures', 'Ventures'],
    ['/blog', 'Blog'],
    ['#contact', 'Contact'],
  ];

  return (
    <>
      <header style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: scrolled ? '14px 28px' : '22px 52px',
        background: scrolled ? 'rgba(255,255,255,0.97)' : 'transparent',
        boxShadow: scrolled ? '0 2px 20px rgba(0,0,0,0.08)' : 'none',
        transition: 'all 0.4s',
      }}>
        <a href="/" style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: '24px', fontWeight: 700, letterSpacing: '1px',
          color: scrolled ? '#1E8449' : '#fff',
          textDecoration: 'none', transition: 'color 0.4s', zIndex: 101,
        }}>
          Gracious
        </a>

        {/* Desktop Nav */}
        <nav style={{
          display: 'flex', alignItems: 'center', gap: '36px',
          '@media (max-width: 768px)': { display: 'none' },
        }} className="desktop-nav">
          {navLinks.map(([href, label]) => (
            <a key={label} href={href} style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: '13px', fontWeight: 500, letterSpacing: '1.5px',
              textTransform: 'uppercase', textDecoration: 'none',
              color: scrolled ? '#555550' : 'rgba(255,255,255,0.9)',
              transition: 'color 0.3s',
            }}>{label}</a>
          ))}
          <a href="https://wa.me/2347069495976" target="_blank" rel="noreferrer" style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: '12px', fontWeight: 600, letterSpacing: '1.5px',
            textTransform: 'uppercase', textDecoration: 'none',
            padding: '11px 24px', borderRadius: '2px',
            border: scrolled ? '1.5px solid #1E8449' : '1.5px solid rgba(255,255,255,0.8)',
            color: scrolled ? '#1E8449' : '#fff',
            transition: 'all 0.3s',
          }}>Work With Me</a>
        </nav>

        {/* Hamburger Button */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="hamburger"
          style={{
            display: 'none',
            flexDirection: 'column', gap: '5px',
            background: 'none', border: 'none',
            cursor: 'pointer', padding: '8px', zIndex: 101,
          }}
        >
          <span style={{
            display: 'block', width: '24px', height: '2px',
            background: scrolled ? '#1E8449' : '#fff',
            transition: 'all 0.3s',
            transform: menuOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none',
          }} />
          <span style={{
            display: 'block', width: '24px', height: '2px',
            background: scrolled ? '#1E8449' : '#fff',
            transition: 'all 0.3s',
            opacity: menuOpen ? 0 : 1,
          }} />
          <span style={{
            display: 'block', width: '24px', height: '2px',
            background: scrolled ? '#1E8449' : '#fff',
            transition: 'all 0.3s',
            transform: menuOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none',
          }} />
        </button>
      </header>

      {/* Mobile Menu Overlay */}
      <div style={{
        position: 'fixed', inset: 0, zIndex: 99,
        background: 'rgba(26,92,56,0.98)',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', gap: '36px',
        opacity: menuOpen ? 1 : 0,
        pointerEvents: menuOpen ? 'all' : 'none',
        transition: 'opacity 0.3s ease',
      }}>
        {navLinks.map(([href, label]) => (
          <a key={label} href={href}
            onClick={() => setMenuOpen(false)}
            style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: '32px', fontWeight: 700,
              color: '#fff', textDecoration: 'none',
              letterSpacing: '1px',
            }}>{label}</a>
        ))}
        <a href="https://wa.me/2347069495976" target="_blank" rel="noreferrer"
          onClick={() => setMenuOpen(false)}
          style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: '13px', fontWeight: 600, letterSpacing: '2px',
            textTransform: 'uppercase', textDecoration: 'none',
            padding: '14px 32px', borderRadius: '2px',
            border: '1.5px solid rgba(255,255,255,0.6)',
            color: '#fff', marginTop: '16px',
          }}>Work With Me</a>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .hamburger { display: flex !important; }
        }
      `}</style>
    </>
  );
}
